import React from 'react'
import { Text, Button, Icon } from 'components'
import styles from './PartnershipButton.module.scss'

const PartnershipButton = ({ description, iconType, onClick }) => {
  return (
    <Button className={styles.partnerButton} onClick={onClick}>
      <Icon
        className={styles.icon}
        type={iconType}
        size={48}
        color="primaryColor"
      />
      <Text fontSize="large" color="darkBlueColor">
        Parceria
      </Text>
      <Text fontSize="regular" color="darkBlueColor" bold>
        {description}
      </Text>
    </Button>
  )
}

export default React.memo(PartnershipButton)
